import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";
import ProductList from "../pages/products/page";
import ProductDetail from "../pages/products/detail/page";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Dashboard from "../pages/dashboard/page";
import Cart from "../pages/dashboard/Cart";
import Recharge from "../pages/dashboard/Recharge";
import Withdraw from "../pages/dashboard/Withdraw";
import KycApply from "../pages/dashboard/KycApply";
import MyOrders from "../pages/dashboard/MyOrders";
import RechargeAudit from "../pages/admin/RechargeAudit";
import WithdrawalAudit from "../pages/admin/WithdrawalAudit";
import ProductManage from "../pages/admin/ProductManage";
import OrderManage from "../pages/admin/OrderManage";
import MemberManage from "../pages/admin/MemberManage";
import AdminDashboard from "../pages/admin/Dashboard";
import AdminSettings from "../pages/admin/Settings";
import KycAudit from "../pages/admin/KycAudit";
import GuidePage from "../pages/guide/page";
import AdminRoute from "../components/feature/AdminRoute";
import ManualOrder from "../pages/admin/ManualOrder";
import TotalOrdersManage from "../pages/admin/TotalOrdersManage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductList />,
  },
  {
    path: "/products/:id",
    element: <ProductDetail />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/dashboard/cart",
    element: <Cart />,
  },
  {
    path: "/dashboard/recharge",
    element: <Recharge />,
  },
  {
    path: "/dashboard/withdraw",
    element: <Withdraw />,
  },
  {
    path: "/dashboard/kyc",
    element: <KycApply />,
  },
  {
    path: "/dashboard/orders",
    element: <MyOrders />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminRoute><AdminDashboard /></AdminRoute>,
  },
  {
    path: "/admin/recharge",
    element: <AdminRoute><RechargeAudit /></AdminRoute>,
  },
  {
    path: "/admin/withdrawals",
    element: <AdminRoute><WithdrawalAudit /></AdminRoute>,
  },
  {
    path: "/admin/products",
    element: <AdminRoute><ProductManage /></AdminRoute>,
  },
  {
    path: "/admin/orders",
    element: <AdminRoute><OrderManage /></AdminRoute>,
  },
  {
    path: "/admin/members",
    element: <AdminRoute><MemberManage /></AdminRoute>,
  },
  {
    path: "/admin/settings",
    element: <AdminRoute><AdminSettings /></AdminRoute>,
  },
  {
    path: "/admin/kyc",
    element: <AdminRoute><KycAudit /></AdminRoute>,
  },
  {
    path: "/admin/manual-order",
    element: <AdminRoute><ManualOrder /></AdminRoute>,
  },
  {
    path: "/admin/total-orders",
    element: <AdminRoute><TotalOrdersManage /></AdminRoute>,
  },
  {
    path: "/guide",
    element: <GuidePage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
